import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  chip: {
    alignItems: 'center',
    backgroundColor: theme.new.color.brand[100],
    borderRadius: '4px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    gap: '4px',
    padding: '2px 8px',

    '&:hover': {
      backgroundColor: theme.new.color.brand[200],
    },
  },
  chipIcon: {
    height: '16px',
    width: '16px',
  },
}));

export default useStyles;
